import { Alert, Button, Flex, Input, Select, Text } from '@rocket/ui';
import { useState } from 'react';

const PAPER_TYPE_OPTIONS = [
  { value: 'third_party', label: 'Third Party Paper — you review their contract' },
  {
    value: 'first_party',
    label: 'First Party Paper — you provide the contract (coming soon)',
    disabled: true,
  },
];

const CONTRACT_TYPE_OPTIONS = [
  { value: 'nda', label: 'NDA' },
  { value: 'subcontract', label: 'Subcontract' },
  { value: 'servicesagreement', label: 'Services Agreement' },
];

interface Props {
  onBack: () => void;
  onNext: (config: {
    name: string;
    paperType: 'first_party' | 'third_party';
    contractType: string;
  }) => void;
  isLoading?: boolean;
  isReturningUser?: boolean;
}

export function OnboardingPlaybookSetup({
  onBack,
  onNext,
  isLoading,
  isReturningUser = false,
}: Props) {
  const [name, setName] = useState('');
  const [paperType, setPaperType] = useState<'first_party' | 'third_party'>('third_party');
  const [contractType, setContractType] = useState('nda');

  const handleNext = () => {
    if (!name.trim()) {
      return;
    }
    onNext({ name: name.trim(), paperType, contractType });
  };

  return (
    <Flex.V gap="5" p="6">
      <Text fontWeight="700" fontSize="lg">
        Configure Your Playbook
      </Text>

      <Input
        label="Playbook name"
        required
        placeholder="e.g. Standard NDA Playbook"
        value={name}
        onChange={(e) => setName(e.target.value)}
      />

      <Select
        label="Paper type"
        options={PAPER_TYPE_OPTIONS}
        value={[paperType]}
        onChange={(e) =>
          setPaperType(JSON.parse(e.target.value)[0] as 'first_party' | 'third_party')
        }
      />

      <Select
        label="Contract type"
        options={CONTRACT_TYPE_OPTIONS}
        value={[contractType]}
        onChange={(e) => setContractType(JSON.parse(e.target.value)[0] as string)}
      />

      <Alert status="info">
        {paperType === 'third_party'
          ? 'Third Party Paper: BlackBoiler will extract rules from the edits your team made to incoming contracts. Upload contracts with tracked changes.'
          : 'First Party Paper: BlackBoiler will extract rules from what survived into the final signed contract. Upload final executed documents.'}
      </Alert>

      <Flex.H gap="2" justify="flex-end">
        <Button variant="ghost" size="sm" onClick={onBack} disabled={isLoading}>
          Back
        </Button>
        <Button
          colorPalette="gray"
          size="sm"
          disabled={!name.trim() || isLoading}
          loading={isLoading}
          loadingText="Creating…"
          onClick={handleNext}
        >
          Next
        </Button>
      </Flex.H>
    </Flex.V>
  );
}
